import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const feed = articles
  .filter((item) => item.timeline && item.timeline.length > 0)
  .slice(0, 4);

export default function LiveTicker() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-8 md:px-6 md:py-10">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950 md:text-xl">
            <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-flashlight-line text-sm" />
            </span>
            实时速报
          </h2>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
            持续更新中
          </span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {feed.map((item) => {
            const last = item.timeline![item.timeline!.length - 1];
            return (
              <Link
                key={item.id}
                to={`/article/${item.id}`}
                className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <span className="flex items-center gap-2 font-heading text-sm font-black text-primary-600">
                  <i className="ri-alarm-line" />
                  {last.time}
                </span>
                <p className="mt-2.5 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {last.text}
                </p>
                <span className="mt-3 flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-primary-700">
                  <i className="ri-arrow-right-s-line" />
                  查看事件时间线
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}